import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {Store} from '@ngxs/store';
import {SeekTo} from '../../store/player.actions';
import {PlayerState} from '../../store/player.state';

@Component({
  selector: 'gg-bottom-panel',
  templateUrl: './bottom-panel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BottomPanelComponent implements OnInit {
  public isSeekable$ = this.store.select(state => state.player.isSeekable);
  public currentTime$ = this.store.select(state => state.player.timings.currentTime);
  public totalTime$ = this.store.select(state => state.player.timings.totalTime);
  public isLive$ = this.store.select(state => state.player.isLive);

  constructor(private store: Store) {
  }

  ngOnInit() {
  }

  onSeek(position) {
    this.store.dispatch(new SeekTo({position}));
  }

}
